(function () {
  angular.module('MktzapApp.Controllers')
    	.controller('NotificationTrackerStatusController', status);

  status.$inject = ['$http', 'FoundationApi', 'NotificationTrackerStatusService', 'NotificationService', '$state', '$timeout', '$rootScope', '$sce', 'LocalStorageService'];

  function status ($http, FoundationApi, NotificationTrackerStatusService, NotificationService, $state, $timeout, $rootScope, $sce, LocalStorageService) {
    if (LocalStorageService.checkInPause()) {
      LocalStorageService.sendToBlockPage();
    }
    var vm = this;

    NotificationTrackerStatusService.getSendingChannels({},
      function (data) {
        vm.sending_channels = data;
      });

    vm.notification_tracker_statuses = NotificationTrackerStatusService.query();
    vm.openCreate = openCreate;
    vm.openEdit = openEdit;
    vm.confirmDelete = confirmDelete;
    vm.removeStatus = removeStatus;
    vm.save = save;
    vm.cancel = cancel;
    vm.sending = false;

    function openCreate () {
      vm.sending = false;
      vm.old = vm.notification_tracker_status = {};
      FoundationApi.publish('statusCreateModal', 'open');
    }
    function openEdit (status) {
      vm.sending = false;
      vm.old = status;
      vm.notification_tracker_status = status;
      FoundationApi.publish('statusEditModal', 'open');
    }
    function confirmDelete (status) {
      vm.deleting = status;
      FoundationApi.publish('statusConfirmDeleteModal', 'open');
    }
    function removeStatus (status) {
		    vm.sending = true;
      NotificationTrackerStatusService
        .remove({ id: status.id })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.sucRemoveStatus);
          FoundationApi.publish('statusConfirmDeleteModal', 'close');
          if (parseInt(status.should_close) == 0) {
            $timeout(function () {
              vm.sending = false;
              $state.reload();
            }, 3000);
          } else {
            vm.notification_tracker_statuses = NotificationTrackerStatusService.query();
          }
        })
        .catch(function (e) {
          vm.sending = false;
          NotificationService.errorHandler(e, $rootScope.labels.errorRemoveStatus);
        });
    }
    function cancel () {
      vm.notification_tracker_statuses = NotificationTrackerStatusService.query();
    }

    function save () {
      vm.sending = true;
      if (vm.old.id) {
        NotificationTrackerStatusService
          .update(vm.notification_tracker_status)
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, $rootScope.labels.sucUpdateStatus);
            FoundationApi.publish('statusEditModal', 'close');
            if (parseInt(vm.notification_tracker_status.should_close) == 0) {
              $timeout(function () {
                vm.sending = false;
                $state.reload();
              }, 3000);
            } else {
              vm.notification_tracker_statuses = NotificationTrackerStatusService.query();
            }
          })
          .catch(function (e) {
            vm.sending = false;
            NotificationService.errorHandler(e, $rootScope.labels.errorUpdateStatus);
          });
      } else {
        // Criar novo status
        NotificationTrackerStatusService
          .save(vm.notification_tracker_status)
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, $rootScope.labels.sucCreateStatus);
            FoundationApi.publish('statusCreateModal', 'close');
            vm.notification_tracker_statuses = NotificationTrackerStatusService.query();
          })
          .catch(function (e) {
            vm.sending = false;
            NotificationService.errorHandler(e, $rootScope.labels.errorCreateStatus);
          });
      }
    }
    vm.checkBitwise = function (check, value) {
      return check & value;
    }
  }
})();
